module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDE0Ij48ZyBmaWxsPSIjZmYwMDNjIj48Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSI2Ii8+PHBhdGggZD0iTTI0IDQ4QzEwLjc0NSA0OCAwIDM3LjI1NSAwIDI0UzEwLjc0NSAwIDI0IDBzMjQgMTAuNzQ1IDI0IDI0LTEwLjc0NSAyNC0yNCAyNHptMC0xNmE4IDggMCAxIDAgMC0xNiA4IDggMCAwIDAgMCAxNnoiIGZpbGwtb3BhY2l0eT0iLjQiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/breachroom-pin.svg
// module id = 495
// module chunks = 28901507966785 35783957827783